export default {
  vote: {
    title: "投票计量",
    list: {
      empty: "读取投票",
      header: {
        rank: "排名",
        account: "账户",
        votePercent: "投票百分比",
        decayedVote: "衰退的投票",
        website: "网站"
      },
      legend: {
        runnerUps: "第二位",
        standBy: "待命中",
        active: "活跃"
      }
    }
  }
}
